<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-tabs>
                <b-tab title="Basisgegevens" active>
                  <b-row>
                    <b-col cols="12">
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Titel">
                            <b-form-input type="text" required v-model="item.title" :disabled="saveButtonDisabled || !editable"></b-form-input>
                          </b-form-group>
                          <b-form-group label="Preview">
                            <b-form-input type="text" required v-model="item.preview" :disabled="saveButtonDisabled || !editable"></b-form-input>
                          </b-form-group>
                          <b-form-group label="Foto">
                            <p v-if="current_featured_image"><img :alt="current_featured_image.name" :src="current_featured_image.url" class="img img-thumbnail" width="100"><br>
                              <a href="#" v-if="editable" @click.prevent="clearFeaturedImage">Verwijder afbeelding</a></p>
                            <b-form-file v-else v-model="featuredImageFile" :disabled="saveButtonDisabled || !editable" placeholder="Selecteer een bestand..."></b-form-file>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                          <b-form-group label="Uitgelicht">
                            <b-form-checkbox
                              required
                              @input="value => item.featured = value"
                              :checked="!!item.featured"
                              switch
                              size="md"
                              :disabled="saveButtonDisabled || !editable"
                            >
                              {{ item.featured ? 'Ja' : 'Nee' }}
                            </b-form-checkbox>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <hr>
                          <div v-if="editable">
                          <b-button @click.prevent="cancelEdit" class="mr-3" variant="warning">Annuleren</b-button>
                            <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                          </div>
                          <div v-if="!editable">
                          <b-button type="button" @click.prevent="editable = true" variant="primary" class="pull-right">Bewerken</b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="Blokken">
                  <blocks :page="item" @refresh="refresh"/>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { updateData, getData } from '../../api';
import Blocks from './tabs/Blocks';

export default {
  name: 'news-article',
  components: {
    Blocks,
  },

  data() {
    return {
      saveButtonDisabled: false,
      editable: false,
      item: {},
      featuredImageFile: null,
    };
  },

  methods: {
    async refresh() {
      await this.getItem();
    },

    async getItem() {
      this.item = await getData('news-articles/' + this.$route.params.id).then(
        (response) => response.data.data
      );
    },

    async saveItem() {
      this.saveButtonDisabled = true;

      let formData = new FormData();
      Object.keys(this.item).forEach(key => {
        let value = this.item[key];

        if (key === 'featured') {
          value = +value;
        }

        formData.append(key, value);
      });

      const request = await updateData('news-articles/' + this.$route.params.id, formData);

      if (request.status === 200) {
        this.editable = false;
        this.saveButtonDisabled = false;
        await this.getItem();
      } else {
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    clearFeaturedImage() {
      this.item.featured_image = '';
      this.item.new_featured_image = '';
    },
  },

  computed: {
    userRole: function() {
      return this.$store.state.userRole;
    },
    current_featured_image () {
      return this.item && this.item.featured_image;
    }
  },

  watch: {
    'featuredImageFile'(newValue) {
      this.item.new_featured_image = newValue;
    }
  },
  beforeMount() {
    this.getItem();
  },
};
</script>

<style>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
